import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import Breadcrumb from '../components/Breadcrumb';
import { Link } from 'react-router-dom';
import '../styles/Dashboard.css';
import Topbar from '../components/Topbar';

export default function Dashboard() {
  const { roles } = useContext(AuthContext);

  const isAdminOrOdonto = roles.includes('ADMIN') || roles.includes('DOCTOR');

  return (
    <>
      <Topbar />
      <div className="dashboard">
        <Breadcrumb />
        <h1>Panel de Control</h1>
        <div className="widget-grid">
          <Link to="/pacientes" className="widget">
            <h3>Pacientes</h3>
            <p>Registro pacientes, tratamientos, presupuestos...</p>
          </Link>

          {isAdminOrOdonto && (
            <Link to="/facturacion/general" className="widget">
            <h3>Facturación</h3>
            <p>⚠️**Próximamente saldrá lo facturado la semana**</p>
          </Link>
          )}
          <div to="/calendario" className="widget">
            <h3>Calendario ⚠️</h3>
            <p>Próximamamente</p>
          </div>
{/*           <Link to="/calendario" className="widget">
            <h3>Calendario ⚠️</h3>
            <p>Proximamamente</p>
          </Link> */}
        </div>
      </div>
    </>
  );
}
